import { debounce } from "../utils";
import $ from "jquery";
export default class NewModals {
  constructor() {
    this.modals = $(".new-modal");

    this.handleLinks();
    this.handleClose();

    $(window).on(
      "resize",
      debounce(() => {
        this.handleLinks();
      }, 500)
    );
  }

  handleLinks() {
    $("[data-toggle-modal]").off("click");
    $("[data-toggle-modal]").on("click", (e) => {
      e.preventDefault();
      let id = $(e.currentTarget).data("toggle-modal");
      NewModals.open(id);
    });
  }

  handleClose() {
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.modals.each((i, e) => {
          NewModals.close(e.id);
        });
      }
    });

    this.modals.each((i, e) => {
      $(e).on("click", ".new-modal__close", () => {
        NewModals.close(e.id);
      });
    });

    this.modals.each((i, e) => {
      $(e).on("click", (event) => {
        if (event.currentTarget === event.target) {
          NewModals.close(e.id);
        }
      });
    });
  }

  static open(modal) {
    $(".new-modal#" + modal).addClass("new-modal--open");
    $("body").css("overflow", "hidden");

    // Trigger custom event
    const event = new CustomEvent("newmodalopened", { detail: { modal } });
    document.dispatchEvent(event);
  }

  static close(modal) {
    if (modal) {
      $(".new-modal#" + modal).removeClass("new-modal--open");
      $("body").css("overflow", "");

      // Trigger custom event
      const event = new CustomEvent("newmodalclosed", { detail: { modal } });
      document.dispatchEvent(event);
    }
  }
}

window.closeModal = (modalId) => {
  NewModals.close(modalId);
};
